import React from "react";
import "./Timeline.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import WorkIcon from "@material-ui/icons/Work";
import SchoolIcon from "@material-ui/icons/School";
import StarRateIcon from "@material-ui/icons/StarRate";
import { ThemeContext } from "../../Context/theme";

export const Timeline = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [linecolor, setlinecolor] = React.useState(
    themename === "light" ? "#23283e" : "#fcfcfc"
  );

  React.useEffect(() => {
    if (themename === "dark") {
      setlinecolor("#fcfcfc");
    } else {
      setlinecolor("#23283e");
    }
  }, [themename]);
  return (
    <>
      <div className="section mainsection">
        <h2 className="section__title" data-aos="fade-right">
          My <span className="different" id="time">Timeline 💫</span>
        </h2>
        <VerticalTimeline lineColor={linecolor}>
        
        
      
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"june 2016 -  Dec 2021"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
             Qualification
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            ></h4>
            <p data-aos="fade-right">
              completed my graduation and post graduation In  BCA (bachelor of Computer Application) + MCA(master of Computer Application) integrated Course.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"June 2017 "}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Certification 
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            ></h4>
            <p data-aos="fade-right">
           Certification In Core java, C, C++, MS-Office.
             AICTE Approved.
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"April 2013 - june 2015 "}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
            Schooling 
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            ></h4>
            <p data-aos="fade-right">
            Completed  Higher Secondary Education In  Science stream  With PCMB.
             from S.K.V. No. 1,  Palam colony, New Delhi
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            icon={<StarRateIcon />}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
          ></VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </>
  );
};


//  <VerticalTimelineElement
//       //   date={"April 2022 - Feb 2023"}
//       //   contentStyle={{
//       //     boxShadow: `var(--shadow)`,
//       //     backgroundColor: `var(--clr-bg)`,
//       //     textAlign: "center",
//       //     color: `var(--clr-fg-alt)`,
//       //   }}
//       //   contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
//       //   iconStyle={{
//       //     backgroundColor: `var(--clr-bg)`,
//       //     color: `var(--clr-primary)`,
//       //   }}
//       //   icon={<SchoolIcon />}
//       // >
//       //   <h3
//       //     className="vertical-timeline-element-title"
//       //     data-aos="fade-right"
//       //   >
//       //     Student
//       //   </h3>
//       //   <h4
//       //     className="vertical-timeline-element-subtitle"
//       //     data-aos="fade-right"
//       //   >
//       //     Masai School (Remote)
//       //   </h4>
//       //   <p data-aos="fade-right">
//       //     Joined the Military style Bootcamp to learn Software Development
//       //     and Data Structures. Also learned many soft skills in the process.
//       //   </p>
//       // </VerticalTimelineElement>